import { render, staticRenderFns } from "./AppLayout.vue?vue&type=template&id=31c3fae6&"
import script from "./AppLayout.vue?vue&type=script&lang=js&"
export * from "./AppLayout.vue?vue&type=script&lang=js&"
import style0 from "./AppLayout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Alert: require('/home/runner/work/lareverde-shop/lareverde-shop/components/core/Alert.vue').default,Header: require('/home/runner/work/lareverde-shop/lareverde-shop/components/blocks/Header.vue').default,Footer: require('/home/runner/work/lareverde-shop/lareverde-shop/components/blocks/Footer.vue').default})
